import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { HardHat, Zap, Sprout, Mountain } from 'lucide-react';

const iconMap = {
  HardHat,
  Zap,
  Sprout,
  Mountain
};

const Industries = () => {
  const { t } = useLanguage();

  return (
    <section id="industries" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t.industries.title}
          </h2>
          <p className="text-xl text-gray-600">
            {t.industries.subtitle}
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {t.industries.items.map((industry, index) => {
            const Icon = iconMap[industry.icon];
            return (
              <Card
                key={index}
                className="group hover:shadow-2xl transition-all duration-300 border-2 border-gray-100 hover:border-orange-500 cursor-pointer"
              >
                <CardHeader>
                  <div className="flex items-center space-x-4 mb-2">
                    <div className="w-12 h-12 rounded-lg bg-orange-100 flex items-center justify-center group-hover:bg-orange-500 transition-colors duration-300">
                      <Icon className="w-6 h-6 text-orange-500 group-hover:text-white transition-colors duration-300" />
                    </div>
                    <CardTitle className="text-2xl font-bold text-gray-900">
                      {industry.title}
                    </CardTitle>
                  </div>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-gray-600 leading-relaxed text-base">
                    {industry.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Industries;
